import { Injectable } from '@angular/core';
import { UtilsService } from '@ebw-monorepo/utils';

@Injectable({
  providedIn: 'root'
})
export class ListServiceService {

  constructor(
    private requestUtils: UtilsService
  ) { }

  getList(fullUrl: string){
    return this.requestUtils.getRequest(fullUrl, {});
  }


}
